import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/admin/add-client/[id]/success/page";

export const Route = createFileRoute("/admin/add-client/$clientId/success")({
  component: Page,
});
